import { apiClient } from '../lib/apiClient';

// Subset of the mobile app's src/api/subscription.ts — web only needs to read
// status for the access gate. There is no purchase flow on web (Phase 0 decision:
// providers subscribe in the mobile app).

export type SubscriptionStatusValue =
  | 'trial'
  | 'active'
  | 'cancelled'
  | 'expired'
  | 'grace_period';

export type SubscriptionStatus = {
  status: SubscriptionStatusValue;
  isTrialActive: boolean;
  trialDaysRemaining: number;
  trialExpiryDate: string | null;
  isSubscribed: boolean;
  plan: 'monthly' | 'quarterly' | 'yearly' | null;
  subscriptionExpiryDate: string | null;
};

export const subscriptionApi = {
  getStatus: () => apiClient.get<SubscriptionStatus>('/subscription/status'),
};

// ── Access decision — same logic as CareTeamTabNavigator in the app ──────────

export type CTAccess =
  | { state: 'trial'; daysLeft: number }
  | { state: 'active' }
  | { state: 'expired' };

export function evaluateAccess(sub: SubscriptionStatus): CTAccess {
  const now = new Date();
  const trialValid =
    sub.isTrialActive && !!sub.trialExpiryDate && new Date(sub.trialExpiryDate) > now;
  const subValid =
    sub.isSubscribed &&
    !!sub.subscriptionExpiryDate &&
    new Date(sub.subscriptionExpiryDate) > now;
  const grace = sub.status === 'grace_period';

  if (subValid || grace) return { state: 'active' };
  if (trialValid) return { state: 'trial', daysLeft: Math.max(0, sub.trialDaysRemaining) };
  return { state: 'expired' };
}
